/**
 * Tenant-aware theme entry point.
 *
 * REACT_APP_TENANT is a build-time constant injected by CodeBuild ("jameo" | "attraction").
 * webpack's DefinePlugin replaces process.env.REACT_APP_TENANT with a string literal,
 * so Terser evaluates the conditions and drops the dead branch entirely.
 *
 * Rule: always use `if` / ternary — never a dict/object keyed on the tenant.
 * See skills/tenant-theme/SKILL.md for the full rationale.
 */
import { SxProps } from "@mui/material";
import { byTenant } from "../utils/byTenant";

import {
  spacing as jameoSpacing,
  palette as jameoPalette,
  gradient as jameoGradient,
  theme as jameoTheme,
  TextGradientStyles as jameoTextGradientStyles,
} from "./theme.jameo";

import {
  spacing as attractionSpacing,
  palette as attractionPalette,
  gradient as attractionGradient,
  theme as attractionTheme,
  TextGradientStyles as attractionTextGradientStyles,
} from "./theme.attraction";

export const spacing = byTenant(jameoSpacing, attractionSpacing);
export const palette = byTenant(jameoPalette, attractionPalette);
export const gradient = byTenant(jameoGradient, attractionGradient);
export const theme = byTenant(jameoTheme, attractionTheme);
export const TextGradientStyles = byTenant(
  jameoTextGradientStyles,
  attractionTextGradientStyles
);

export type Styles = { [key: string]: SxProps };
export const createStyles = <T extends Styles>(styles: T): T => styles;
